/**
 * Names matching every word in the query, in the order they were given.
 * An empty query keeps the full list so focusing the field can show it.
 */
export function matchingAppointmentTypes<T extends { name: string }>(
  types: readonly T[],
  query: string,
): T[] {
  const tokens = query
    .trim()
    .toLocaleLowerCase('da')
    .split(/\s+/)
    .filter((token) => token.length > 0);
  if (tokens.length === 0) return [...types];
  return types.filter((type) => {
    const name = type.name.toLocaleLowerCase('da');
    return tokens.every((token) => name.includes(token));
  });
}
